import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { CancelRounded, CheckCircleRounded } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../bootstrap/ConfigProvider';

export default function PasswordValidations({ hasValue, errors }) {
    const { t } = useTranslation();
    const { passwordRequirements } = useConfig();

    return (
        <div>
            <PasswordValidation
                hasValue={hasValue}
                error={errors.length}
                message={t('ChangePassword.Length', { length: passwordRequirements.requiredLength })}
            />
            <PasswordValidation
                hasValue={hasValue}
                error={errors.upperCase}
                message={t('ChangePassword.AtLeastOneUpperCase')}
                show={passwordRequirements.requireUppercase}
            />
            <PasswordValidation
                hasValue={hasValue}
                error={errors.lowerCase}
                message={t('ChangePassword.AtLeastOneLowerCase')}
                show={passwordRequirements.requireLowercase}
            />
            <PasswordValidation
                hasValue={hasValue}
                error={errors.numeric}
                message={t('ChangePassword.AtLeastOneDigit')}
                show={passwordRequirements.requireDigit}
            />
            <PasswordValidation
                hasValue={hasValue}
                error={errors.specialChar}
                message={t('ChangePassword.OneSpecialCharacter')}
                show={passwordRequirements.requireNonAlphanumeric}
            />
        </div>
    );
}

function PasswordValidation({ hasValue, error, message, show = true }) {
    const classes = useStyles();

    if (!show) {
        return null;
    }

    return (
        <div className={classes.root}>
            {error ? (
                <CancelRounded fontSize='small' className={clsx(classes.invalid, classes.icon)} />
            ) : (
                <CheckCircleRounded
                    fontSize='small'
                    className={clsx(hasValue && classes.valid, classes.icon)}
                />
            )}
            <Typography color='textSecondary' variant='body2'>
                {message}
            </Typography>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    icon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(0.5)
    },
    valid: {
        color: '#45aa45'
    },
    invalid: {
        color: '#f44467'
    }
}));
